import { QuestionRegulatoryData, Questionnaire, QuestionnaireQuestion } from "../../Models/Surveys/SurveyDataModel";
import { BaseRegulationLogicManager } from "../BaseRegulationLogicManager";
import ResourcesConstants from "../ResourceConstants";
import {ComplianceScoreResult, InventoryDetailsResponse} from "../../StateControllers/Survey/SurveyResponse/SurveyResponseModels";

export class ReachRegistrationCustomLogicManager extends BaseRegulationLogicManager {
    public static ReachRegistrationRegulationId = "0620b9e0-37de-4b60-ac48-4ca76f0d4c8d";


    private readonly q1Id: string = "1";
    private readonly q2Id: string = "2";
    private readonly q3Id: string = "3";
    private readonly q4Id: string = "4";
    private readonly q5Id: string = "5";
    private readonly q6Id: string = "6";
    private readonly q7Id: string = "7";
    private readonly q8Id: string = "8";
    private readonly q9Id: string = "9";
    private readonly q10Id: string = "10";
    private readonly q11Id: string = "11";
    private readonly q12Id: string = "12";
    private readonly polymer: string = "Polymer"; // localization: resources for extraction
    private readonly exemptFromRegistration: string = "Exempt from Registration";
    private readonly other: string = "Other";

    constructor(questions: QuestionnaireQuestion[], overallQuestionnaire: Questionnaire, questionRegulatoryData: QuestionRegulatoryData[], selectedInventory: InventoryDetailsResponse | null, complianceScoreResult: ComplianceScoreResult | null) {
        super(questions, overallQuestionnaire, questionRegulatoryData, selectedInventory, complianceScoreResult);
    }

    protected getAdditionalQuestionIndicesToHide = (question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) => {
        if (question.id === this.q1Id) {
            let childQuestion2 = this._questions.findIndex(q => q.id === this.q2Id);
            let childQuestion3 = this._questions.findIndex(q => q.id == this.q3Id);
            let childQuestion4 = this._questions.findIndex(q => q.id == this.q4Id);
            let childQuestion5 = this._questions.findIndex(q => q.id == this.q5Id);
            let childQuestion6 = this._questions.findIndex(q => q.id == this.q6Id);
            let childQuestion7 = this._questions.findIndex(q => q.id == this.q7Id);
            let childQuestion8 = this._questions.findIndex(q => q.id == this.q8Id);
            let childQuestion9 = this._questions.findIndex(q => q.id == this.q9Id);
            let childQuestion10 = this._questions.findIndex(q => q.id == this.q10Id);
            let childQuestion11 = this._questions.findIndex(q => q.id == this.q11Id);
            let childQuestion12 = this._questions.findIndex(q => q.id == this.q12Id);
            indicesToHideOrShow[childQuestion2] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion3] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion4] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion5] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion6] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion7] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion8] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion9] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion10] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion11] = question.value === this.polymer;
            indicesToHideOrShow[childQuestion12] = question.value ===this.polymer;
        }
        if (question.id === this.q2Id) {
            let childQuestion3 = this._questions.findIndex(q => q.id == this.q3Id);
            indicesToHideOrShow[childQuestion3] = question.value !== this.exemptFromRegistration;
        }
        if (question.id === this.q4Id) {
            let childQuestion5 = this._questions.findIndex(q => q.id == this.q5Id);
            let childQuestion6 = this._questions.findIndex(q => q.id == this.q6Id);
            let childQuestion7 = this._questions.findIndex(q => q.id == this.q7Id);
            let childQuestion8 = this._questions.findIndex(q => q.id == this.q8Id);
            let childQuestion9 = this._questions.findIndex(q => q.id == this.q9Id);
            let childQuestion10 = this._questions.findIndex(q => q.id == this.q10Id);
            let childQuestion11 = this._questions.findIndex(q => q.id == this.q11Id);

            indicesToHideOrShow[childQuestion5] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion6] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion7] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion8] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion9] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion10] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
            indicesToHideOrShow[childQuestion11] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;
        }

        return indicesToHideOrShow;
    }

    public customIsQuestionRequired = (question: QuestionnaireQuestion) => {
        if (question.id === ResourcesConstants.UniversalFieldIds.SupplierComments) {
            const questionValue = this._questions.find(q => q.id === this.q3Id)?.value ?? "";

            if (questionValue.toLowerCase() === this.other.toLowerCase()) {
                return true;
            }
        }

        return false;
    }
}
